<template>
  <div class="appBody prh-main" v-if="projectObj">
    <!--    <div class="shareImg position-fixed cursor-pointer">-->
    <!--      <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">-->

    <!--    </div>-->
    <course-top type="shome" :lastLearnedSession="lastLearnCourseObj"
                :shomeRate="rate" :currentItem="projectObj"
                :canClickLearn="canLearn"></course-top>
    <div class="bg-white py-1"></div>
    <van-tabs v-model="active" class="sub-home-course" @disabled="goPage">
      <van-tab>
        <template #title>
          <div class="myct d-flex align-items-center position-relative">
            我的课程
            <img @click="showTag" v-if="!isShow" class="downImg position-absolute" src="/static/img/pro/download.png"
                 alt="">
            <img @click="showTag" v-else class="downImg position-absolute" src="/static/img/pro/hide.png" alt="">
          </div>

        </template>
        <div v-if="isShow" class="courseTag-list bg-ee py-2 d-flex px-3">
          <div v-for="ctag in option" :key="ctag.value"
               :class="{'active': ctag.value===value}" class="tag ml-12"
               @click="getCourse(ctag.value)">{{ctag.text}}
          </div>
        </div>
      </van-tab>

      <van-tab :disabled="!projectObj.canSignUp" :url="'/recommend-project/'+projectId">
        <template #title>
          <div class="myct d-flex align-items-center position-relative">
            选择课程
            <img class="downImg position-absolute" src="/static/img/pro/commentShare.png" alt="">
          </div>
        </template>
      </van-tab>
    </van-tabs>

    <div class="cor-adv-list px-3 mt-3" v-if="myCourseList && myCourseList.length > 0">
      <row-card-component :cardList="myCourseList" :proTimeObj="proTimeObj" typeBlock="sub-course"
                          class="border-bottom-0">
      </row-card-component>
      <div class="text-center pt-3">
        <img width="25%" :src="noMoreImage">
      </div>
    </div>
    <no-data v-else text="暂无数据"></no-data>
    <little-footer></little-footer>
  </div>

</template>

<script>
  import RowCardComponent from "@/components/rowCardComponent";
  import CourseTop from '@/components/courseTop'
  import SubMyCourse from '@/page/subject-home/components/subMyCourse'
  // import RecommendCourse from '@/page/subject-home/components/recommendCourse'
  import TeacherCourse from '@/components/teacherCourse'
  import littleFooter from '@/page/lecturer/components/littleFooter';

  import Vue from 'vue';
  import {Dialog, Icon} from 'vant';
  import {List} from 'vant';
  import {Cell, CellGroup} from 'vant';
  import {Tab, Tabs} from 'vant';
  import {Progress} from 'vant';
  import {DropdownMenu, DropdownItem} from 'vant';
  import NoData from "@/components/noData";
  import {mapState} from "vuex";

  Vue.use(DropdownMenu);
  Vue.use(DropdownItem);
  Vue.use(Tab);
  Vue.use(Tabs);
  Vue.use(Cell);
  Vue.use(CellGroup);
  Vue.use(List);
  Vue.use(Icon);
  Vue.use(Progress);

  export default {
    name: "subjectHome",
    components: {
      NoData,
      CourseTop,
      SubMyCourse,
      // RecommendCourse,
      TeacherCourse,
      littleFooter,
      RowCardComponent,
    },
    data() {
      return {
        active: 0,
        loading: false,
        finished: false,
        myCourseList: [],
        courseList: [],
        recommendList: [],
        expertList: [],
        value: 0,
        rate: 0,
        option: [
          {text: '全部', value: 0},
          {text: '未开始', value: 1},
          {text: '进行中', value: 2},
          {text: '已完成', value: 3},
        ],
        isShow: false,
        projectObj: {},
        projectId: '',
        shareObj: {},
        totalCnt: 0,
        proTimeObj: {},
        lastLearnCourseObj: {},
        canLearn: false
      }
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl,
        noMoreImage: state => state.noMoreImage,
        canSignUpTip: state => state.canSignUp
      })
    },
    mounted() {
      this.projectId = this.$route.params['id'];
      this.getProject();
    },
    methods: {
      getProject() {
        this.$store.dispatch('getProjectForLearner', {id: this.projectId}).then((res) => {
          this.projectObj = res;
          this.proTimeObj.proName = this.projectObj.name;
          this.proTimeObj.proLearningStartTime = this.projectObj.learningStartTime;
          this.proTimeObj.proLearningEndTime = this.projectObj.learningEndTime;
          sessionStorage.setItem("currentProject", JSON.stringify(this.projectObj));
          this.getCourseList();
        })
      },

      getCourseList() {
        //添加浏览器title
        this.$store.commit('SET_BROWHEADERTITLE', {
          browserHeaderTitle: this.projectObj.name
        });

        let arr = [];
        this.myCourseList = [];

        if (this.projectObj.statInfo) {
          if (this.projectObj.statInfo.signedUpCount && this.projectObj.statInfo.signedUpCount !== 0 && this.projectObj.statInfo.learnedCount && this.projectObj.statInfo.learnedCount !== 0) {
            this.rate = (this.projectObj.statInfo.learnedCount / this.projectObj.statInfo.signedUpCount) * 100
          } else {
            this.rate = 0;
          }
        } else {
          this.rate = 0;
        }

        if (this.projectObj.courseList && this.projectObj.courseList.length > 0 && this.projectObj.userProject && this.projectObj.userProject.courseList && this.projectObj.userProject.courseList.length > 0) {
          for (let j of this.projectObj.courseList) {
            ///获取最后一个学习的课程并得到是否可以点击
            if(this.projectObj.userProject.lastLearnCourseId && this.projectObj.userProject.lastLearnCourseId===j.projectId) {
              this.lastLearnCourseObj = j;
            }else {
              this.lastLearnCourseObj = this.projectObj.courseList[0];
            }
            this.isCanLearn();

            for (let i of this.projectObj.userProject.courseList) {
              if (j.courseId === i.courseId) {
                let obj = Object.assign(j, i);
                if (obj.course) {
                  //处理tags
                  this.getNewTag(obj);
                  if (obj.course.statInfo) {
                    this.totalCnt = obj.course.statInfo.mustLearnSessionCount ? obj.course.statInfo.mustLearnSessionCount : 0;
                  }

                  if (obj.userCourse) {
                    let learnedCnt = obj.userCourse.progress ? obj.userCourse.progress : 0;
                    obj.learnedCnt = learnedCnt;
                    obj.totalCnt = this.totalCnt;
                    obj.courseRate = (learnedCnt / this.totalCnt) * 100;

                    //处理切换状态时的列表
                    if (obj.learnedCnt === obj.totalCnt) {
                      obj.myState = 3;
                    } else if (learnedCnt === 0) {
                      obj.myState = 1;
                    } else if (obj.learnedCnt > 0 && obj.learnedCnt < obj.totalCnt) {
                      obj.myState = 2;
                    }

                  } else {
                    obj.learnedCnt = 0;
                    obj.totalCnt = this.totalCnt;
                    obj.courseRate = 0;
                    obj.myState = 1;
                  }
                } else {
                  obj.learnedCnt = 0;
                  obj.totalCnt = this.totalCnt;
                  obj.courseRate = 0;
                  obj.myState = 1;
                }
                arr.push(obj);
              }
            }
          }
        }

        this.myCourseList = arr.sort(this.compare('sort'));
        this.courseList = arr.sort(this.compare('sort'));
      },
      compare(property) {
        return function (a, b) {
          let value1 = a[property];
          let value2 = b[property];
          return value1 - value2;
        }
      },
      isCanLearn() {
        let nowTime = new Date().getTime();
        if (nowTime >= this.projectObj.learningStartTime && nowTime <= this.projectObj.learningEndTime
          && (!this.lastLearnCourseObj.learningTimeLimit || (nowTime >= this.lastLearnCourseObj.learningStartTime && nowTime <= this.lastLearnCourseObj.learningEndTime))) {
          this.canLearn = true;
        } else {
          this.canLearn = false;
        }
      },
      getCourse(n) {
        this.myCourseList = [];
        this.value = n;
        if (n > 0) {
          for (let m of this.courseList) {
            if (m.myState && m.myState === n) {
              this.myCourseList.push(m)
            }
          }
        } else {
          this.myCourseList = this.courseList
        }
      },
      showTag() {
        this.isShow = !this.isShow;
      },
      getNewTag(obj) {
        //处理tag的长度,大于22个字，显示2个。否则显示3个
        if (obj.course && obj.course.tag && obj.course.tag.length > 0) {
          let tagArr = [];
          let len = 0;
          tagArr = obj.course.tag.slice(0, 3);
          for (let t of tagArr) {
            len += t.length;
            if (len >= 22) {
              tagArr.slice(0, 2);
            } else {
              tagArr.slice(0)
            }
          }
          obj.tags = tagArr;
        } else {
          obj.tags = [];
        }
      },
      // onShare() {
      //   //把生成海报需要的信息传入cookie
      //
      //   this.shareObj = this.projectObj;
      //   this.shareObj.qrcodeUrl = window.location.href;
      //   this.shareObj.fromPageType = 'project';
      //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj))
      //   this.$router.push('/share-poster');
      // },
      //跳转至选课页面
      goPage() {
        if(!this.projectObj.canSignUp) {
          this.$toast(this.canSignUpTip);
        }else {
          this.$router.push('/recommend-project/'+this.projectId);
        }
      }
    },

  }
</script>

<style>
  .prh-main {
    background: #eeeeee;
  }
  .sub-home-course .course-nav .van-tabs__nav--card {
    width: 80%;
    border: none;
    margin: 0;
    border-radius: 0;
    height: 1.875rem;
    background-color: #eeeeee;
  }

  .sub-home-course .course-nav .van-tabs__nav--card .van-tab {
    display: flex;
    justify-content: flex-start;
  }

  .sub-home-course .van-tabs__nav--card .van-tab {
    border-right: 0;
    padding: 0;
  }

  .sub-home-course .van-tabs__line {
    width: 1.5rem !important;
    height: .1875rem !important;
    background: #2474ff;
  }

  .sub-home-course .course-nav .van-tabs__nav--card .van-tab.van-tab--active {
    background: #eeeeee;
  }

  .sub-home-course .course-nav .van-tabs__nav--card .van-tab .van-tab__text {
    background-color: #e3e3e3;
    border-radius: .25rem;
  }

  .sub-home-course .course-nav .van-tabs__nav--card .van-tab.van-tab--active .van-tab__text {
    background-color: white;
  }

  .sub-home-course .van-tab {
    color: #666666;
    font-size: 1rem;
    line-height: 1.25rem;
    font-weight: bold;
  }

  .sub-home-course .van-tab.van-tab--active {
    color: #333333;
  }

  .sub-home-course > .van-tabs__wrap {
    height: 3rem;
  }

  .sub-home-course .course-nav .van-tabs__wrap {
    height: 1.875rem;
  }

  .sub-home-course .van-hairline--top-bottom::after, .sub-home-course .van-hairline-unset--top-bottom::after {
    border-width: 0
  }

  .sub-home-course .van-hairline--top-bottom::after {
    border-bottom: none !important;
  }

  .courseTag-list {
    box-shadow: 0 0 12px 0 #6c757d4f;
  }

  .courseTag-list .tag {
    color: #888888;
    background: #eeeeee;
    padding: .5rem .875rem;
    border-radius: .5rem;
    font-size: .75rem;
    line-height: .875rem;
    cursor: pointer;
  }

  .courseTag-list .tag.active {
    color: #333333;
    background: #dddddd;
  }

  .van-tabs__nav .van-tab .van-tab__text {
    padding: 0 1.625rem;
  }

  .myct .downImg {
    right: -1.625rem;
  }
</style>
